import { AppBar, TitlePortal } from 'react-admin'
import Box from '@mui/material/Box'
import GlobalExpirationSetting from '../components/common/GlobalExpirationSetting'

const MyAppBar = (props) => (
  <AppBar {...props}>
    <TitlePortal />
    <Box flex="1" />
    <GlobalExpirationSetting />
  </AppBar>
)

export default MyAppBar
